import React, { useState, useMemo } from 'react';
import { observer } from 'mobx-react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AssessmentQuestionPreview from '../../../../containers/assessment/AssessmentQuestionPreview';
import {
    FlexDiv,
    SpaceBetweenDiv,
    Heading4,
} from '@awarego-ui/components';
import { useStores } from '../../../../hooks/use-stores';

function PreviewModal({ question, userName, userEmail, onClose }) {
    const { authStore } = useStores();
    const [blockNum, setBlockNum] = useState(0);
    const [blockValues, setBlockValues] = useState({});
    const [completedBlocks, setCompletedBlocks] = useState([]);

    // Create mock data for preview
    const mockQuestion = useMemo(
        () => ({
            ...question,
            id: question.id || 'preview',
            definition: {
                ui: question.ui,
            },
        }),
        [question]
    );

    const mockQuestionsSelected = useMemo(
        () => [mockQuestion.id],
        [mockQuestion.id]
    );
    const mockSelectedQuestionId = mockQuestion.id;
    const mockSetSelectedQuestionId = () => {};

    const handleBlockChange = (value, actionId) => {
        setBlockValues((prev) => ({
            ...prev,
            [actionId]: value,
        }));
    };

    const handleQuestionAction = (questionId, action, value) => {
        console.log('Question action:', { questionId, action, value });
    };

    const handleNextBlock = () => {
        if (blockNum < question.ui.blocks.length - 1) {
            setBlockNum((prev) => prev + 1);
        }
    };

    const handlePrevBlock = () => {
        if (blockNum > 0) {
            setBlockNum((prev) => prev - 1);
        }
    };

    const handleNextLesson = () => {
        // Mock next lesson
        console.log('Next lesson');
    };

    const handlePreviousLesson = () => {
        // Mock previous lesson
        console.log('Previous lesson');
    };

    const hasNextBlock = () => {
        return blockNum < question.ui.blocks.length - 1;
    };

    const hasPreviousBlock = () => {
        return blockNum > 0;
    };

    return (
        <Dialog
            open={true}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            fullScreen
        >
            <DialogTitle>
                <SpaceBetweenDiv alignCenter>
                    <Heading4>Question Preview</Heading4>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </SpaceBetweenDiv>
            </DialogTitle>

            <DialogContent style={{ padding: 0 }}>
                <AssessmentQuestionPreview
                    companyId="preview"
                    question={mockQuestion}
                    isReview={false}
                    questionsSelected={mockQuestionsSelected}
                    selectedQuestionId={mockSelectedQuestionId}
                    setSelectedQuestionId={mockSetSelectedQuestionId}
                    hasMoreQuestions={false}
                    isMovingBack={false}
                    setIsMovingBack={() => {}}
                    onRequestClose={onClose}
                    loadingData={false}
                    isWizard={false}
                    hideFooter={false}
                    // Mock props for preview
                    blockNum={blockNum}
                    blockValues={blockValues}
                    completedBlocks={completedBlocks}
                    onBlockChange={handleBlockChange}
                    onQuestionAction={handleQuestionAction}
                    onNextBlock={handleNextBlock}
                    onPrevBlock={handlePrevBlock}
                    onNextLesson={handleNextLesson}
                    onPreviousLesson={handlePreviousLesson}
                    hasNextBlock={hasNextBlock()}
                    hasPreviousBlock={hasPreviousBlock()}
                />
            </DialogContent>
        </Dialog>
    );
}

export default observer(PreviewModal);

